module.exports = __webpack_public_path__ + "static/img/7-Secrets-of-Fertitta-Hall-at-USC-Marshall-thumbnail.90a0aa3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/7-Secrets-of-Fertitta-Hall-at-USC-Marshall-thumbnail.jpg
// module id = kuak
// module chunks = 1